export default __webpack_public_path__ + "static/media/infoImg1.c2760048.png";